import React, { useState } from "react";
import styled from "styled-components";
import { Card, CardBody, ChevronDownIcon, ChevronUpIcon, Button } from "@pancakeswap/uikit";
import { motion, AnimatePresence } from "framer-motion";

// Custom styled button
export const StyledButton = styled(Button)`
  margin-top: 8px;
  width: 100%;
  background: transparent;
  border-top: 2px solid #A99C7B;
  border-bottom: 2px solid #A99C7B;
  border-left: none;
  border-right: none;
  color: white;
  font-weight: bold;
  border-radius: 0; /* Optional: remove border-radius if you want sharp edges */
 `;

// Collapsible section
const CollapsibleSection: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card
      className="w-full shadow-md"
      style={{
        maxWidth: "400px",
        width: "100%",
        background: "#000",
        color: "white",
        marginTop: "10px",
        marginBottom: "40px",
        borderLeft: "none",
        borderRight: "none",
       
        borderRadius: "0", // optional for squared look
      }}
    >
      <StyledButton
        variant="tertiary"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="flex justify-between items-center w-full text-left"
      >
        <span className="text-lg font-semibold">{title}</span>
        {open ? <ChevronUpIcon className="w-5 h-5" /> : <ChevronDownIcon className="w-5 h-5" />}
      </StyledButton>

      <AnimatePresence>
        {open && (
          <motion.div
            className="overflow-hidden"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
          >
            <CardBody className="mt-3 text-sm text-white">{children}</CardBody>
          </motion.div>
        )}
      </AnimatePresence>
    </Card>
  );
};

const BridgeGuide: React.FC = () => {
  return (
    <div className="w-full max-w-[400px] mx-auto p-4">
      <CollapsibleSection title="BridgeGuide">
        <ul className="list-disc ml-6 space-y-1">
          <li>Connect your wallet on BNB Chain.</li>
          <li>Input your Ethereum address and amount.</li>
          <li>Approve the VizslaSwap tokens.</li>
          <li>Click &quot;Transfer to Ethereum&quot; to lock the tokens.</li>
          <li>Please wait while the system processes your transaction. (It may take up to 2 minutes.)</li>
          <li>Check if you&apos;ve received the tokens on the Ethereum network.(If anything goes wrong, let us know.)</li>
        </ul>
      </CollapsibleSection>
    </div>
  );
};

export default BridgeGuide;
